/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&name=Operlog&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=Operlog&lang=js"

import "./index.vue?vue&type=style&index=0&id=f677bbee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f677bbee"]])

export default __exports__